

export default function NotFound() {
   return (
    <>
    <h1>No such path exists in this React dom</h1>
    </>
   )
}